module.exports = __webpack_public_path__ + "media/proksee-viewer/images/search-ends-with-4628ab6cc6d8fcb5a0aa77a37e289cf5.png";